import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=48fca10f&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=48fca10f&prod&lang=css&scoped=true"
import style1 from "./Upload.vue?vue&type=style&index=1&id=48fca10f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fca10f",
  null
  
)

export default component.exports